
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","stroke":"#C0C0CC","stroke-width":"1.6","stroke-linecap":"round","stroke-linejoin":"round","fill":"currentColor","d":"M16.999 1.05a1.2 1.2 0 011.076.669l4.356 8.825 9.741 1.423a1.2 1.2 0 01.664 2.047l-7.048 6.865 1.664 9.698a1.2 1.2 0 01-1.742 1.265L17 27.26l-8.712 4.58a1.2 1.2 0 01-1.74-1.264l1.662-9.698-7.047-6.865a1.2 1.2 0 01.663-2.047l9.742-1.423 4.356-8.825a1.2 1.2 0 011.076-.67z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./public/dist/img/ax-max-pro/star.svg